import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";

import ScrollToTop from "../pages/ScrollToTop";
import Home from "../pages/Home";
import About from "../Components/About";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import DeveloperCard from "../Components/DeveloperCard";
import Products from "../Components/products/Products";
import ProcessSection from "../Components/ProcessSection";
import ContactExport from "../Components/ContactUS";

function Layout() {
  const location = useLocation();

  return (
    <>
      <ScrollToTop />
      <Navbar />

      {/* ✅ TOASTER (GLOBAL) */}
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="light" // ✅ white theme
      />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products/:category" element={<Products />} />
        <Route path="/products" element={<Products />} />
        <Route path="/process" element={<ProcessSection />} />
        <Route path="/developer" element={<DeveloperCard />} />
        <Route path="/contact" element={<ContactExport />} />
      </Routes>

      {/* Hide Footer on /developer */}
      {location.pathname !== "/developer" && <Footer />}
    </>
  );
}

function AppRoutes() {
  return (
    <Router>
      {/* <screenTop/> */}
      <Layout />
    </Router>
  );
}

export default AppRoutes;
